import { RequestAction } from '@redux-requests/core';

import enclaveMapper from 'shared/utils/api/mappers/enclaveMapper';
import { Enclave, RawEnclaveMetadata } from 'shared/types/enclave';

import * as actions from './actions';

export const fetchEnclaves = (): RequestAction => ({
  type: actions.FETCH_ENCLAVES,
  payload: {
    request: {
      url: '/services/enclaves',
    },
  },
  meta: {
    onSuccess: (response) => response.map(enclaveMapper.mapFromApi),
  },
});

export const fetchEnclaveMetadata = (): RequestAction => ({
  type: actions.FETCH_ENCLAVE_METADATA,
  payload: {
    request: {
      url: '/services/subscriptions',
    },
  },
});

export const enrichEnclavesWithMetadata = (
  enclaves: Enclave[],
  enclaveMetadata: RawEnclaveMetadata[] = [],
) => ({
  type: actions.ENRICH_ENCLAVES_WITH_METADATA,
  payload: {
    enclaves,
    enclaveMetadata,
  },
});
